const Mahta = {
    RechargePDP: {
        widget: null,
        widgetOverlay: null,
        blackFridayDiscount: null,
        productInfo: null,
        productInfoBlurClass: 'mahta-loading',
        productInfoBlurTimeout: null,
        variantSelectsSelector: 'variant-selects',
        wrapperOptionOneTime: null,
        wrapperOptionSubscription: null,
        wrapperBenefitsSubscription: null,
        rechargeOriginalPrice: null,
        rechargeDiscountedPrice: null,
        rechargeOriginalPriceVariant: null,
        rechargeDiscountedPriceVariant: null,

        overlayPricesSynced: false,
        _overlayDiscountObserver: null,

        init: function () {
            this.productInfo = document.querySelector('product-info');
            if (this.productInfo === null) return;

            this.addProductInfoBlur();
            this.attachVariantSelectsListeners();

            const waitForRechargeWidget = (callback) => {
                const target = document.body;
                const observer = new MutationObserver(() => {
                    this.attachVariantSelectsListeners();
                    this.widget = document.querySelector("recharge-subscription-widget");
                    this.widgetOverlay = document.querySelector("#recharge-storefront-experiences__cart-overlay");
                    if (this.widget && this.widget.shadowRoot) {
                        observer.disconnect();
                        callback(this.widget);
                    }
                });
                observer.observe(target, { childList: true, subtree: true });
            };

            waitForRechargeWidget((widget) => {
                if (!widget.shadowRoot) return;
                this.widget = widget.shadowRoot;
                this.updateRechargeInfo(1000);
                this.updateRechargeOnetimePriceFromVariantSelects();
                this.attachAddToCartListener();
            });
        },

        attachAddToCartListener: function () {
            const addToCartButton = document.querySelector('button[name="add"]');
            if (!addToCartButton) {
                return;
            }

            addToCartButton.addEventListener('click', () => {

                const checkOverlayTimer = setInterval(() => {
                    this.widgetOverlay = document.querySelector("#recharge-storefront-experiences__cart-overlay");

                    if (this.widgetOverlay) {
                        clearInterval(checkOverlayTimer);

                        setTimeout(() => {
                            this.syncOverlayPriceWithWidget();
                        }, 300);
                    }
                }, 100);

                setTimeout(() => {
                    clearInterval(checkOverlayTimer);
                }, 5000);
            });
        },

        attachVariantSelectsListeners: function () {
            const variantSelectsNodes = document.querySelectorAll(this.variantSelectsSelector);
            if (!variantSelectsNodes.length) return;

            variantSelectsNodes.forEach((variantSelect) => {
                if (variantSelect.dataset.mahtaRechargeListenerAdded === 'true') return;

                const handleChange = () => {
                    Mahta.RechargePDP.updateRechargeOnetimePriceFromVariantSelects();
                };

                variantSelect.querySelectorAll('select, input[type="radio"]').forEach((element) => {
                    element.addEventListener('change', handleChange);
                });

                variantSelect.dataset.mahtaRechargeListenerAdded = 'true';
            });
        },

        updateRechargeInfo: function (timer = 0) {
            const selectedInput = document.querySelector('.variant-portion-item input[type="radio"]:checked');
            if (!selectedInput) {
                this.removeProductInfoBlur();
                return;
            }
            const rechargeOriginalPrice = selectedInput.getAttribute('data-bf-discount-compare-price-one-time') || '';
            const rechargeDiscountedPrice = selectedInput.getAttribute('data-bf-discount-price-one-time') || '';
            const rechargeOriginalPriceVariant = selectedInput.getAttribute('data-bf-discount-compare-price-one-time-subscription') || '';
            const rechargeDiscountedPriceVariant = selectedInput.getAttribute('data-bf-discount-price-one-time-subscription') || '';
            Mahta.RechargePDP.setRechargeInfo(rechargeOriginalPrice, rechargeDiscountedPrice, rechargeOriginalPriceVariant, rechargeDiscountedPriceVariant);

            setTimeout(() => {
                Mahta.RechargePDP.applyRechargeInfo();
            }, timer);
        },

        applyRechargeInfo: function () {
            const removeBlur = () => this.removeProductInfoBlur();

            if (!this.widget) {
                removeBlur();
                return;
            }

            this.wrapperOptionOneTime = this.widget.querySelector('.rc-selection__onetime');
            this.wrapperOptionSubscription = this.widget.querySelector('.rc-purchase-option__subscription');
            this.wrapperBenefitsSubscription = this.widget.querySelector('.rc-purchase-option__subscription .rc-purchase-option__sub-container');

            if (!this.wrapperOptionOneTime || !this.wrapperOptionSubscription) {
                removeBlur();
                return;
            }

            const priceOneTime = this.wrapperOptionOneTime.querySelector('.rc-price');
            const priceStrike = this.wrapperOptionSubscription.querySelector('.rc-price.strike-through');
            const priceDiscount = this.wrapperOptionSubscription.querySelector('.rc-price:not(.strike-through)');

            if (priceOneTime) priceOneTime.textContent = this.rechargeDiscountedPrice;
            if (priceStrike) priceStrike.textContent = this.rechargeOriginalPriceVariant;
            if (priceDiscount) priceDiscount.textContent = this.rechargeDiscountedPriceVariant;

            if (this.widgetOverlay && this.widgetOverlay.shadowRoot) {
                const overlayShadow = this.widgetOverlay.shadowRoot;
                const storefrontPortal = overlayShadow.querySelector('.fixed');

                if (storefrontPortal) {
                    const nextDiv = storefrontPortal.nextElementSibling;
                    const overlayPriceContainer = nextDiv.querySelector('.whitespace-nowrap');

                    if (overlayPriceContainer) {
                        const overlayOriginal = overlayPriceContainer.querySelector('.text-storefront-drawer-muted.line-through');
                        const overlayDiscount = overlayPriceContainer.querySelector('.text-storefront-drawer-accent');

                        if (this.wrapperOptionSubscription.classList.contains('rc-purchase-option__selected')) {

                            if (overlayOriginal && this.rechargeOriginalPriceVariant) {
                                overlayOriginal.textContent = this.rechargeOriginalPriceVariant;
                            }

                            if (overlayDiscount && this.rechargeDiscountedPriceVariant) {
                                overlayDiscount.textContent = this.rechargeDiscountedPriceVariant;
                            }

                        } else {
                            if (overlayOriginal && this.rechargeOriginalPrice) {
                                overlayOriginal.textContent = this.rechargeOriginalPrice;
                            }

                            if (overlayDiscount && this.rechargeDiscountedPrice) {
                                overlayDiscount.textContent = this.rechargeDiscountedPrice;
                            }
                        }
                    }
                }
            }

            const toggleSelection = (selected, unselected) => {
                selected.classList.add('rc-purchase-option__selected');
                selected.setAttribute('rc-selected', 'true');
                unselected.classList.remove('rc-purchase-option__selected');
                unselected.removeAttribute('rc-selected');

                const selectedInput = selected.querySelector('.rc-purchase-option__checked-indicator');
                const unselectedInput = unselected.querySelector('.rc-purchase-option__checked-indicator');

                if (selectedInput) selectedInput.setAttribute('checked', 'true');
                if (unselectedInput) unselectedInput.removeAttribute('checked');

                Mahta.RechargePDP.updateRechargeOverlayPrices();

                if (this.wrapperBenefitsSubscription) {
                    setTimeout(() => {
                        const benefitsParent = Array.from(this.wrapperOptionSubscription.querySelectorAll('.rc-purchase-option__sub-container'));
                        benefitsParent[0]?.remove();
                        this.wrapperOptionSubscription.appendChild(this.wrapperBenefitsSubscription);
                    }, 50);
                }
            };

            if (!this.wrapperOptionOneTime.dataset.listenerAdded) {
                this.wrapperOptionOneTime.addEventListener('click', () => {
                    toggleSelection(this.wrapperOptionOneTime, this.wrapperOptionSubscription);
                });
                this.wrapperOptionOneTime.dataset.listenerAdded = 'true';
            }

            if (!this.wrapperOptionSubscription.dataset.listenerAdded) {
                this.wrapperOptionSubscription.addEventListener('click', () => {
                    toggleSelection(this.wrapperOptionSubscription, this.wrapperOptionOneTime);
                });
                this.wrapperOptionSubscription.dataset.listenerAdded = 'true';
            }

            this.updateRechargeOnetimePriceFromVariantSelects();

            const syncTimer = setInterval(() => {
                if (this.widgetOverlay && this.widgetOverlay.shadowRoot) {
                    this.syncOverlayPriceWithWidget();
                    clearInterval(syncTimer);
                }
            }, 100);
            setTimeout(() => {
                clearInterval(syncTimer);
            }, 2000);

            removeBlur();
        },

        updateRechargeOverlayPrices: function () {
            if (!this.widgetOverlay || !this.widgetOverlay.shadowRoot) return;

            const overlayShadow = this.widgetOverlay.shadowRoot;
            const overlayPriceContainer = overlayShadow.querySelector('.flex.justify-between.gap-2');
            if (!overlayPriceContainer) return;
            const overlayOriginal = overlayPriceContainer.querySelector('.text-storefront-drawer-muted.line-through');
            const overlayDiscount = overlayPriceContainer.querySelector('.text-storefront-drawer-accent');
            const isSubscription = this.wrapperOptionSubscription?.classList.contains('rc-purchase-option__selected');

            if (isSubscription) {
                if (overlayOriginal && this.rechargeOriginalPriceVariant)
                    overlayOriginal.textContent = this.rechargeOriginalPriceVariant;
                if (overlayDiscount && this.rechargeDiscountedPriceVariant)
                    overlayDiscount.textContent = this.rechargeDiscountedPriceVariant;
            } else {
                if (overlayOriginal && this.rechargeOriginalPrice)
                    overlayOriginal.textContent = this.rechargeOriginalPrice;
                if (overlayDiscount && this.rechargeDiscountedPrice)
                    overlayDiscount.textContent = this.rechargeDiscountedPrice;
            }
        },

        addProductInfoBlur: function () {
            if (!this.productInfo) return;
            this.productInfo.classList.add(this.productInfoBlurClass);
            this.scheduleProductInfoBlurFallback();
        },

        scheduleProductInfoBlurFallback: function () {
            if (this.productInfoBlurTimeout) {
                clearTimeout(this.productInfoBlurTimeout);
            }
            this.productInfoBlurTimeout = setTimeout(() => {
                this.productInfoBlurTimeout = null;
                this.removeProductInfoBlur();
            }, 10000);
        },

        removeProductInfoBlur: function () {
            if (!this.productInfo) return;
            if (this.productInfoBlurTimeout) {
                clearTimeout(this.productInfoBlurTimeout);
                this.productInfoBlurTimeout = null;
            }
            this.productInfo.classList.remove(this.productInfoBlurClass);
        },

        getSelectedVariantElementFromSelects: function () {
            const scope = this.productInfo ? this.productInfo.closest('section') : document;
            let variantSelects = scope?.querySelector(this.variantSelectsSelector) || document.querySelector(this.variantSelectsSelector);
            if (!variantSelects) return null;

            const radioCandidate = variantSelects.querySelector('input[type="radio"][data-bf-discount-compare-price-one-time]:checked');
            if (radioCandidate) return radioCandidate;

            const selectElements = variantSelects.querySelectorAll('select');
            for (let i = 0; i < selectElements.length; i++) {
                const select = selectElements[i];
                if (!select || !select.options || select.selectedIndex < 0) continue;
                const option = select.options[select.selectedIndex];
                if (option && option.hasAttribute('data-bf-discount-compare-price-one-time')) {
                    return option;
                }
            }

            const ariaCheckedCandidate = variantSelects.querySelector('[data-bf-discount-compare-price-one-time][aria-checked="true"]');
            if (ariaCheckedCandidate) return ariaCheckedCandidate;

            const fallbackInput = document.querySelector('.variant-portion-item input[type="radio"]:checked');
            if (fallbackInput?.hasAttribute('data-bf-discount-compare-price-one-time')) return fallbackInput;

            return null;
        },

        updateRechargeOnetimePriceFromVariantSelects: function () {
            if (!this.widget) return;

            const selectedVariantElement = this.getSelectedVariantElementFromSelects();
            if (!selectedVariantElement) return;

            const priceValue = selectedVariantElement.getAttribute('data-bf-discount-compare-price-one-time');
            const discountedValue = selectedVariantElement.getAttribute('data-bf-discount-price-one-time');

            if (!this.wrapperOptionOneTime) {
                this.wrapperOptionOneTime = this.widget.querySelector('.rc-selection__onetime');
            }
            if (!this.wrapperOptionOneTime) return;

            const priceElement = this.wrapperOptionOneTime.querySelector('.rc-price');
            if (!priceElement) return;

            const pricesContainer = this.wrapperOptionOneTime.querySelector('.rc-purchase-option__prices');
            if (!pricesContainer) return;

            let regularPriceElement = pricesContainer.querySelector('.rc-price-regular');
            if (!regularPriceElement) {
                regularPriceElement = document.createElement('span');
                regularPriceElement.classList.add('rc-price-regular', 'strike-through');
                pricesContainer.insertBefore(regularPriceElement, priceElement);
            }

            if (priceValue) {
                regularPriceElement.textContent = priceValue;
            }

            if (discountedValue) {
                priceElement.textContent = discountedValue;
            }

            this.updateRechargeOverlayPrices();
        },

        setRechargeInfo: function (originalPrice, discountedPrice, originalPriceVariant, discountedPriceVariant) {
            this.rechargeOriginalPrice = originalPrice;
            this.rechargeDiscountedPrice = discountedPrice;
            this.rechargeOriginalPriceVariant = originalPriceVariant;
            this.rechargeDiscountedPriceVariant = discountedPriceVariant;
        },

        waitForNextDiv: function (element, callback) {
            const check = () => {
                let next = element.nextSibling;

                while (next && next.nodeType !== 1) {
                    next = next.nextSibling;
                }

                if (next) {
                    callback(next);
                } else {
                    setTimeout(check, 100);
                }
            };

            check();
        },

        syncOverlayPriceWithWidget: function () {
            if (this.overlayPricesSynced) {
                return;
            }

            if (!this.widgetOverlay) {
                return;
            }

            const shadow = this.widgetOverlay.shadowRoot;
            if (!shadow) {
                return;
            }

            const storefrontPortal = shadow.querySelector('#storefront-portal')
                || shadow.querySelector('.fixed')
                || shadow.querySelector('[role="dialog"]');

            const proceedWithOverlayDrawer = (overlayDrawer) => {
                if (!overlayDrawer) {
                    return;
                }

                const overlayPriceContainer = overlayDrawer.querySelector('.whitespace-nowrap, .text-right.whitespace-nowrap');
                if (!overlayPriceContainer) {
                    return;
                }

                const overlayOriginal = overlayPriceContainer.querySelector('.text-storefront-drawer-muted.line-through');
                const overlayDiscount = overlayPriceContainer.querySelector('.text-storefront-drawer-accent');

                if (!overlayDiscount) return;

                if (!Mahta.RechargePDP.widget) {
                    return;
                }

                const widgetSubscriptionDiscount = Mahta.RechargePDP.widget.querySelector('[part="rc-purchase-option__discounted-price"]');
                if (!widgetSubscriptionDiscount) {
                    return;
                }

                const overlayDiscountText = overlayDiscount.textContent?.trim();
                const widgetDiscountText = widgetSubscriptionDiscount.textContent?.trim();

                if (overlayDiscountText === widgetDiscountText) {
                    Mahta.RechargePDP.overlayPricesSynced = true;
                    attachOverlayObserver(overlayDiscount, widgetDiscountText);
                    return;
                }

                overlayDiscount.textContent = widgetDiscountText;
                Mahta.RechargePDP.overlayPricesSynced = true;
                attachOverlayObserver(overlayDiscount, widgetDiscountText);
            };

            if (!storefrontPortal) {
                const directOverlayDrawer = shadow.querySelector('#cart-overlay-drawer') || Array.from(shadow.querySelectorAll('*')).find(el => el.id === 'cart-overlay-drawer');
                if (!directOverlayDrawer) {
                    return;
                }
                proceedWithOverlayDrawer(directOverlayDrawer);
                return;
            }

            this.waitForNextDiv(storefrontPortal, (nextDiv) => {
                if (!nextDiv) {
                    return;
                }
                let overlayDrawer = null;
                try { overlayDrawer = nextDiv.querySelector('#cart-overlay-drawer'); } catch (e) { overlayDrawer = null; }
                if (!overlayDrawer) overlayDrawer = shadow.querySelector('#cart-overlay-drawer');
                proceedWithOverlayDrawer(overlayDrawer);
            });

            function attachOverlayObserver(overlayDiscountEl, expectedValue) {
                if (Mahta.RechargePDP._overlayDiscountObserver) {
                    Mahta.RechargePDP._overlayDiscountObserver.disconnect();
                    Mahta.RechargePDP._overlayDiscountObserver = null;
                }

                const observer = new MutationObserver((mutations) => {
                    const current = overlayDiscountEl.textContent?.trim();
                    if (current !== expectedValue) {
                        overlayDiscountEl.textContent = expectedValue;
                    }
                });

                observer.observe(overlayDiscountEl, { characterData: true, childList: true, subtree: true });

                Mahta.RechargePDP._overlayDiscountObserver = observer;
            }
        },
    }
};

document.addEventListener("DOMContentLoaded", () => {
    Mahta.RechargePDP.init();
});

(function setupCardBuyClickLogger() {
    const BUY_BUTTON_SELECTOR = [
        'button[name="add"]',
        'button[name="add-subscribe"]',
        '.quick-add__submit[name="add"]',
        '.quick-add__submit[name="add-subscribe"]',
        '[data-add-to-cart]',
        '.product-form__submit'
    ].join(', ');

    const CARD_SELECTOR = [
        '.grid__item',
        '.card-wrapper',
        '.card',
        'li',
        '[data-product-card]',
        '[data-product-id]'
    ].join(', ');

    document.addEventListener('click', function (ev) {
        const btn = ev.target.closest(BUY_BUTTON_SELECTOR);
        if (!btn) return;

        const btnText = btn.textContent?.trim().toLowerCase() || '';
        if (btnText.includes('assinar')) {
            return;
        }

        const form = btn.closest('form');
        const hasSellingPlan = form?.querySelector('input[name="selling_plan"]');
        if (hasSellingPlan && hasSellingPlan.value) {
            return;
        }

        const card = btn.closest(CARD_SELECTOR);
        if (!card) {
            return;
        }

        const productNameEl =
            card.querySelector('.card__heading a') ||
            card.querySelector('.card-information__text h3') ||
            card.querySelector('[class*="product"][class*="title"]') ||
            card.querySelector('h3 a') ||
            card.querySelector('a[href*="/products/"]');

        const productName = productNameEl?.textContent?.trim() || '';

        const originalEl =
            card.querySelector('s.price-item.price-item--regular') ||
            card.querySelector('.price__sale s.price-item--regular') ||
            card.querySelector('.price-item--regular') ||
            card.querySelector('s.price-item') ||
            card.querySelector('s');

        const discountEl =
            card.querySelector('.price-item--sale') ||
            card.querySelector('.price-item--last') ||
            card.querySelector('.price__sale .price-item:not(.price-item--regular)') ||
            card.querySelector('[class*="price"][class*="sale"]');

        const original = originalEl?.textContent?.trim() || null;
        const discount = discountEl?.textContent?.trim() || null;

        if (original) {
            const originalNumeric = parseFloat(original.replace(/[^\d,]/g, '').replace(',', '.'));

            if (!isNaN(originalNumeric) && originalNumeric > 0) {
                let totalDiscountPercent;
                let calculatedDiscount;

                if (productName.toLowerCase().includes('leite vegetal')) {
                    totalDiscountPercent = 15;
                    const finalDiscountNumeric = originalNumeric * (1 - totalDiscountPercent / 100);
                    calculatedDiscount = `R$ ${finalDiscountNumeric.toFixed(2).replace('.', ',')}`;
                }
                else if (discount) {
                    const discountNumeric = parseFloat(discount.replace(/[^\d,]/g, '').replace(',', '.'));

                    if (!isNaN(discountNumeric)) {
                        const cardDiscountPercent = ((originalNumeric - discountNumeric) / originalNumeric) * 100;
                        totalDiscountPercent = cardDiscountPercent + 5;
                        const finalDiscountNumeric = originalNumeric * (1 - totalDiscountPercent / 100);
                        calculatedDiscount = `R$ ${finalDiscountNumeric.toFixed(2).replace('.', ',')}`;

                    } else {
                        window.Mahta_OverlayPrefill = {
                            fromCard: true,
                            original,
                            discount
                        };
                        return;
                    }
                } else {
                    window.Mahta_OverlayPrefill = {
                        fromCard: true,
                        original,
                        discount
                    };
                    return;
                }

                window.Mahta_OverlayPrefill = {
                    fromCard: true,
                    original,
                    discount: calculatedDiscount,
                    cardDiscountPercent: totalDiscountPercent,
                    totalDiscountPercent: totalDiscountPercent,
                    productName: productName
                };
            } else {
                window.Mahta_OverlayPrefill = {
                    fromCard: true,
                    original,
                    discount
                };
            }
        } else {
            window.Mahta_OverlayPrefill = {
                fromCard: true,
                original,
                discount
            };
        }

        window.Mahta_WatchOverlayAfterBuyClick({
            poll: 120,
            timeout: 8000,
            logPrefix: '[OverlayWatch]'
        });
    }, true);
})();

window.Mahta_OverlayUtils = {
    _observer: null,

    getOverlayContext(logPrefix = '[OverlayUtils]') {
        const overlayHost = document.querySelector('#recharge-storefront-experiences__cart-overlay');
        const shadow = overlayHost?.shadowRoot || null;
        if (!shadow) {
            return null;
        }

        let overlayDrawer = shadow.querySelector('#cart-overlay-drawer');
        if (!overlayDrawer) {
            overlayDrawer = Array.from(shadow.querySelectorAll('*')).find(el => el.id === 'cart-overlay-drawer') || null;
        }
        if (!overlayDrawer) {
            return null;
        }

        const discountEl =
            overlayDrawer.querySelector('[part="money discount"]') ||
            overlayDrawer.querySelector('.font-semibold.text-storefront-drawer-accent.text-sm') ||
            overlayDrawer.querySelector('.text-storefront-drawer-accent');

        const originalEl =
            overlayDrawer.querySelector('[part="money"].text-storefront-drawer-muted.line-through') ||
            overlayDrawer.querySelector('.text-storefront-drawer-muted.line-through');

        const originalText = originalEl?.textContent?.trim() || null;
        const discountText = discountEl?.textContent?.trim() || null;
        return { overlayHost, shadow, overlayDrawer, originalEl, discountEl, originalText, discountText };
    },

    alignOverlayWithCard(logPrefix = '[OverlayUtils][Card→Overlay]') {
        const cardOriginal = window.Mahta_OverlayPrefill?.original?.trim() || null;
        const calculatedDiscount = window.Mahta_OverlayPrefill?.discount?.trim() || null;
        const totalDiscountPercent = window.Mahta_OverlayPrefill?.totalDiscountPercent || null;

        if (!cardOriginal || !calculatedDiscount) {
            return false;
        }

        const ctx = this.getOverlayContext(`${logPrefix}[CAPTURA]`);
        if (!ctx || !ctx.discountEl) return false;

        if (ctx.originalEl && cardOriginal) {
            ctx.originalEl.textContent = cardOriginal;
        }

        ctx.discountEl.textContent = calculatedDiscount;
        this.lockOverlayPrice(ctx.discountEl, calculatedDiscount, `${logPrefix}[LOCK]`);
        const after = ctx.discountEl.textContent?.trim() || null;
        return true;
    },

    lockOverlayPrice(element, expectedValue, logPrefix = '[OverlayLock]') {
        if (this._observer) {
            this._observer.disconnect();
        }

        this._observer = new MutationObserver((mutations) => {
            const currentValue = element.textContent?.trim();
            if (currentValue !== expectedValue) {
                element.textContent = expectedValue;
            }
        });

        this._observer.observe(element, {
            characterData: true,
            childList: true,
            subtree: true
        });
    }
};

window.Mahta_WatchOverlayAfterBuyClick = function (opts = {}) {
    const {
        poll = 120,
        timeout = 8000,
        logPrefix = '[OverlayWatch]'
    } = opts;

    const start = Date.now();
    const timer = setInterval(() => {
        const ctx = window.Mahta_OverlayUtils?.getOverlayContext?.(`${logPrefix}[CAPTURA]`);
        if (ctx && ctx.discountEl) {
            const cardOriginal = window.Mahta_OverlayPrefill?.original?.trim() || null;
            const cardDiscount = window.Mahta_OverlayPrefill?.discount?.trim() || null;

            window.Mahta_OverlayUtils.alignOverlayWithCard(`${logPrefix}`);

            clearInterval(timer);
            return;
        }

        if (Date.now() - start > timeout) {
            clearInterval(timer);
        }
    }, poll);
};
